/**
 * ADAPTER USER: platform → bentuk "flat" yang dipakai UI lama.
 * ----------------------------------------------------------------------------
 * Backend platform memisahkan akun (`user`) dan data karyawan (`employee`):
 *   GET /api/profile → { user: {...}, employee: {...} }
 *   POST /api/auth/login → { token, user: {..role_name..} }
 *
 * UI lama (Dashboard, Profile, dll) terlanjur membaca field datar seperti
 * `user.name`, `user.job_title`, `user.department`. Supaya tidak perlu ubah
 * banyak komponen, kita ratakan di sini menjadi satu objek konsisten.
 */

export function flattenUser({ user, employee } = {}, extra = {}) {
  const u = user || {};
  const e = employee || {};
  return {
    // Identitas akun platform
    id: u.id,
    username: u.username,
    role: u.role || u.role_code,
    role_name: u.role_name || extra.role_name || null,
    status: u.status,
    employee_id: e.id || u.employee_id || null,

    // Data karyawan (dipetakan ke nama field yang dipakai UI lama)
    name: e.full_name || u.username || "Karyawan",
    full_name: e.full_name || null,
    nik: e.nik || null,
    badge_number: e.nik || null,
    job_title: e.job_title || null,
    department: e.department || null,
    attendance_type: e.attendance_type || null, // regular/sales/ecommerce/sopir (dari sync Odoo)
    work_email: e.email || null,
    mobile_phone: e.phone || null,
    manager_id: e.manager_id || null,
    // Nama atasan (di-resolve backend) → dibungkus {name} agar cocok UI lama.
    parent_id: e.manager_name ? { name: e.manager_name } : null,
    // PIC (coach_id Odoo) — relasi terpisah dari atasan di atas.
    pic_id: e.pic_id || null,
    pic_name: e.pic_name || null,
    // Lokasi kerja dari Odoo work_location_id: { name, latitude, longitude, ... }.
    work_location: e.work_location || null,

    // Data bank
    bank_name: e.bank_name || null,
    bank_account: e.bank_account || null,
    bank_holder: e.bank_holder || null,

    // Foto profil (storage_key sudah dibentuk jadi URL absolut oleh backend).
    // Ditampilkan lewat <img> dengan token query (lihat withFileToken).
    photo_url: e.photo_url || null,

    // Field yang belum ada padanannya di platform (biar UI aman, isi null)
    image: null,

    ...extra,
  };
}

// Daftar role yang boleh membuka area /admin.
export const ADMIN_ROLES = ["SUPER_ADMIN", "HR_ADMIN", "MANAGER", "PIC"];

export function isAdminRole(role) {
  return ADMIN_ROLES.includes(role);
}
